import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { LoginRegisterShell } from "../LoginRegisterShell";
import { RegisterForm } from "./RegisterForm";
export const Register = () => {
    const { logReactPixelPageView } = useLogging();
    useEffect(() => {
        logReactPixelPageView();
    }, []);
    return (_jsx(LoginRegisterShell, { children: _jsx(RegisterForm, {}) }));
};
